import { Site } from 'solar-bo';
import { SortHelper } from 'shtools';
import { Output, EventEmitter, Directive } from '@angular/core';
import { DashboardService } from '../../services/dashboard.service';
import { AppInjector } from 'base-models';
import { IDB_filter, DB_filter } from 'solar-bo';

/**
 * class to encapsulta filters
 */
@Directive()
export class DbFilter {


    filtersList: { "name": string, "value": [] , "selected":[]}[] = [];

    @Output() selectionChange: EventEmitter<any> = new EventEmitter<any>();

    constructor() {
    }

    filterAdd(filterName: string, values: any) {
        let f: any = this.filtersList.find(item => item.name == filterName);
        if (f) {
            f.value = values;
        }
        else {
            f = { "name": filterName, "value": values , "selected":values};
            this.filtersList.push(f);
        }
    }
    filterGet(filterName: string) {
        let f: any = this.filtersList.find(item => item.name == filterName);
        if (!f){
            f=[];
        }
        return f;
    }
    filterGetValue(filterName: string) {
        let f: any = this.filtersList.find(item => item.name == filterName);
        if (f){
            return f.value;
        }
        return null;
    }
    

    filterRemove(filterName: string) {
        this.filtersList = this.filtersList.filter(item => item.name != filterName);
    }

    getIDBFilter(): IDB_filter[] {
        let elemSelected: IDB_filter[] = [];
    
        for (let item of this.filtersList){
            this.selectionGetSelected(elemSelected,item.name,item.selected);
        }
   
        return elemSelected;
      }

      private selectionGetSelected(elemSelected: IDB_filter[],fieldKey:string,filter:any[]){
        if (filter && filter.length > 0) {
          let selected=filter;
          elemSelected.push(DB_filter.newFilterByArray(fieldKey, selected ));
        }
      }

    dataChangeNotify() {
        this.selectionChange.next(null);
    }




}